<cheelee-dialog-wrapper class="chl-qr">
  <div class="chl-qr__close">
    <button cheeleeRipple isCenteredRipple (click)="onClose()">
      <cheelee-icon iconId="cross-icon" />
    </button>
  </div>

  <div class="chl-qr__wrapper">
    <div class="chl-qr__content">
      <div class="chl-qr-title">
        <h1 class="chl-qr-title__headline">{{'common:qr.title'|i18nextEager}}</h1>
        <p class="chl-qr-title__subline">{{'common:qr.text'|i18nextEager}}</p>
      </div>

      <div class="chl-qr__actions">
        @for (btn of actionBtns; track $index) {
          <cheelee-squircle class="chl-qr-btn {{ btn.class }}" radius="16">
            <img [src]="'assets/icons/' + btn.icon + '.png'" alt="" class="chl-qr-btn__icon">

            <div class="chl-qr-btn-text">
              <span class="chl-qr-btn-text__headline">{{ btn.headline }}</span>
              <span class="chl-qr-btn-text__title">{{ btn.title }}</span>
            </div>
          </cheelee-squircle>
        }
      </div>
    </div>

    <div class="chl-qr-girl">
      <img class="chl-qr-girl__img" src="assets/img/qr/qr_girl.png" alt="Cheelee">
      <cheelee-qr class="chl-qr-girl__qr" value="https://trk.cheeleepay.com/sl/WaqDRJ?pid=1911&affise_siteid=web&affise_ad=default_qr&affise_deeplink=https://app.getlee.co/market/offers" size="170" />
    </div>
  </div>

  <cheelee-squircle class="chl-qr__bg" radius="40"></cheelee-squircle>

</cheelee-dialog-wrapper>
